import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
export const HotJar: React.FC<{
  hotjarId: string;
}> = t0 => {
  const $ = _c(2);
  const {
    hotjarId
  } = t0;
  if (!hotjarId) {
    return null;
  }
  const t1 = `
                (function(h,o,t,j,a,r){
                    h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                    h._hjSettings={hjid:${hotjarId},hjsv:6};
                    a=o.getElementsByTagName('head')[0];
                    r=o.createElement('script');r.async=1;
                    r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                    a.appendChild(r);
                })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
                `;
  let t2;
  if ($[0] !== t1) {
    t2 = <Script id="_next-hotjar" strategy="lazyOnload" dangerouslySetInnerHTML={{
      __html: t1
    }} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};